import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { PageHero, CTABand } from "../components/Shared";
import { AREAS } from "../data/areas";
import { MapPin, ArrowRight } from "lucide-react";

const BASE = "https://carefirstoh.com";

const Areas = () => (
  <div>
    <Seo title="Service Areas | Home Health Care Across Central Ohio | CareFirst" description="CareFirst Home Health serves Columbus, Westerville, Dublin, Worthington, Gahanna, Reynoldsburg, Grove City, Hilliard and more Central Ohio communities." canonical={BASE + "/service-areas"} />
    <PageHero title="Service Areas Across Central Ohio" subtitle="Compassionate home health care throughout Columbus and its surrounding communities." crumbs={[{ label: "Home", to: "/" }, { label: "Service Areas" }]} />

    <section className="bg-white py-20">
      <div className="max-w-[1240px] mx-auto px-4">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {AREAS.map((a) => (
            <Link key={a.slug} to={`/service-areas/${a.slug}`} className="group rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 p-6">
              <div className="flex items-center gap-2 mb-2"><MapPin size={20} className="text-[#4ca82f]" /><h2 className="font-display text-[#16357a] text-[21px] font-semibold group-hover:text-[#4ca82f] transition-colors">{a.name}, OH</h2></div>
              <p className="text-[#666] text-[14px] leading-relaxed mb-4">{a.intro}</p>
              <span className="inline-flex items-center gap-1 text-[#4ca82f] font-semibold text-[14px]">View {a.name} care <ArrowRight size={15} /></span>
            </Link>
          ))}
        </div>
      </div>
    </section>

    <CTABand />
  </div>
);

export default Areas;
